import { cn } from '@/lib/utils';

/**
 * The mark is a transparent PNG, so it sits directly on the page rather than inside a
 * tinted tile. It carries its own teal-to-mint gradient and reads on either ground,
 * which a tile would only get in the way of.
 *
 * It is wider than it is tall, so height is fixed and width follows — constraining both
 * would squash the orbit into an oval.
 */
/**
 * `compact`: on a narrow phone the wordmark gives way to the header's links and the
 * mark alone is the logo; screen readers still hear the name.
 */
export function Logo({ className, showWordmark = true, compact = false }: { className?: string; showWordmark?: boolean; compact?: boolean }) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      {/*
        Intrinsic size given so the browser reserves the space before the file
        arrives: without it the wordmark starts flush left and jumps 38px right when
        the image lands, which is a layout shift on the first paint of the page
        strangers arrive at. The rendered size still comes from the classes.

        fetchPriority high because it is above the fold and in the running for being
        the largest contentful paint.
      */}
      <img
        src="/logo.png"
        alt=""
        aria-hidden
        width={256}
        height={213}
        fetchPriority="high"
        className="h-8 w-auto shrink-0 select-none"
        draggable={false}
      />
      {showWordmark && (
        <span className={cn('text-[15px] font-semibold tracking-[-0.02em] text-ink', compact && 'max-[459px]:sr-only')}>
          HireOrbit
        </span>
      )}
    </span>
  );
}
